
function loadDatatable(config){

    // fallback ajax source
    if(typeof(config.ajaxSource) == 'undefined' || !config.ajaxSource){
        config.ajaxSource = bmConfig.framework.rootFolder + config.overviewUrl + "/datatable";
    }

    // default datatable config object
    var defaultDatatableConfig = {};

    // initialize popover elements on table draws
    defaultDatatableConfig.drawCallback = function() {
        $('#table-' + config.tableName + ' [title]').tooltip();
        var test = $('#table-' + config.tableName + ' [data-toggle="popover"]').popover({html: true});

        //$('#table-' + config.recordType + ' [data-toggle="tooltip"]').tooltip();
    };

    // extend default datatable config from params
    config.datatableConfig = $.extend(defaultDatatableConfig, config.datatableConfig);

    // create extra params object if not set in params
    // gets send with filter ajax request
    if(typeof(config.extraParams) == 'undefined' || !config.extraParams){
        config.extraParams = {};
    }

    $.ajax({
        type: "POST",
        url: config.ajaxSource,
        data: config.extraParams,
        success: function(result){
            if (result.success == "1") {

                // eval() some params for them to work in local javascript
                result.data.initComplete = eval('('+ result.data.initComplete +')');
                result.data.ajax.data = eval('('+ result.data.ajax.data +')');

                // extend result datatable config with local config
                $.extend(result.data, config.datatableConfig);

                $('#table-' + config.tableName).DataTable(result.data);
            }
        },
    });

}

function initDatatable(tableName) {

    /*
    // @frontend: search filter clear button has been disabled for now
    var filterHtml = 'VERVANGEN DOOR JS VAR';

    $('.dataTables_filter').append(filterHtml);

    $('body').on('click', '.dataTables_filter .clear-filter',function(e) {
        e.preventDefault();
        var control_id = $(this).data('control-id');
        $(control_id).val('');
        $("#table-" + recordType).DataTable().search('').draw();
    });
    */

    $('.multiselect').multiselect({
        buttonText: function(options,select) {
            // @todo frontend: check output layout
            //return select.attr('title') + ' <b class="caret"></b>';
            return select.attr('title');
        },
        selectedClass: null,
        onChange: function(element, checked) {
          $("#table-" + tableName).DataTable().draw();
        },
        includeSelectAllOption: true,
        includeSelectAllDivider: true,
        selectAllValue: "select-all",
        selectAllText: "Alles selecteren",
        maxHeight: 300,
        // @todo frontend: check html output
        buttonClass: 'btn btn-sm btn-default',
        //enableHTML: true
    });
}


// jQuery datatable taalbestand
$.extend( $.fn.dataTable.defaults, {
    language: {
        'url' : '/admin/template/datatable/language'
    },
    'pageLength': 25,
});

// jQuery validator taalbestand
$.getScript('/admin/template/validator/language');

// bootstrap-ckeditor-modal-fix.js
// hack to fix ckeditor/bootstrap compatiability bug when ckeditor appears in a bootstrap modal dialog
//
// Include this AFTER both bootstrap and ckeditor are loaded.

$.fn.modal.Constructor.prototype.enforceFocus = function() {
  modal_this = this
  $(document).on('focusin.modal', function (e) {
    if (modal_this.$element[0] !== e.target && !modal_this.$element.has(e.target).length
    && !$(e.target.parentNode).hasClass('cke_dialog_ui_input_select')
    && !$(e.target.parentNode).hasClass('cke_dialog_ui_input_text')
    && !$(e.target.parentNode).hasClass('cke_dialog_ui_input_textarea')) {
      modal_this.$element.focus()
    }
  })
};